import type {CreatePaymentMethodGiropayData} from '@stripe/stripe-js';
import {AbstractStripePayment, type ConfirmResult, type TokenResult} from './abstract/class-abstract-stripe-payment';
import {billingDetails} from './stripe';
import {type PeachPayCheckoutData} from '../types';

declare const peachpay_checkout_data: PeachPayCheckoutData;

class StripeGiropayPayment extends AbstractStripePayment {
	public gatewayId() {
		return 'peachpay_stripe_giropay';
	}

	public async tokenize(): Promise<TokenResult> {
		const billing_details = billingDetails();

		if (peachpay_checkout_data.page.is_order_pay && peachpay_checkout_data.order_pay_details) {
			billing_details.name = peachpay_checkout_data.order_pay_details.billing_first_name + ' ' + peachpay_checkout_data.order_pay_details.billing_last_name;
		}

		const {paymentMethod, error} = await this.stripe.createPaymentMethod({
			type: 'giropay',
			billing_details,
		} as CreatePaymentMethodGiropayData);

		if (error) {
			const message = error.message ?? 'Failed to tokenize payment method.';

			return [null, {
				paymentStatus: 'creationfailed',
				note: message,
			}];
		}

		if (!paymentMethod?.id) {
			return [null, {
				paymentStatus: 'creationfailed',
				note: 'Failed to tokenize payment method.',
			}];
		}

		return [paymentMethod.id, {}];
	}

	public async confirm(clientSecret: string, intermediateURL?: string): Promise<ConfirmResult> {
		const {paymentIntent, error} = await this.stripe.confirmGiropayPayment(clientSecret, {return_url: intermediateURL});

		if (error) {
			const message = error.message ?? 'Failed to confirm payment.';
			return [null, {
				note: message,
			}];
		}

		if (paymentIntent) {
			return ['success', {}];
		}

		return [null, {}];
	}
}

export {StripeGiropayPayment};
